var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.input
  }, [_c('capusta-input', {
    attrs: {
      "label": _vm.$t('reason.for.refund'),
      "placeholder": _vm.$t('for.example.product.defect')
    },
    model: {
      value: _vm.refund.reason,
      callback: function callback($$v) {
        _vm.$set(_vm.refund, "reason", $$v);
      },
      expression: "refund.reason"
    }
  })], 1), _c('div', {
    class: _vm.$style.switcher
  }, [_c('cs-switcher', {
    attrs: {
      "label": _vm.$t('notify.about.refund')
    },
    model: {
      value: _vm.refund.alert,
      callback: function callback($$v) {
        _vm.$set(_vm.refund, "alert", $$v);
      },
      expression: "refund.alert"
    }
  })], 1), _vm.refund.alert ? _c('div', {
    class: _vm.$style.input
  }, [_c('capusta-input', {
    attrs: {
      "label": _vm.$t('email.for.notification'),
      "placeholder": "name@domain.ru"
    },
    model: {
      value: _vm.refund.email,
      callback: function callback($$v) {
        _vm.$set(_vm.refund, "email", $$v);
      },
      expression: "refund.email"
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }